// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared Design Variables for Admin Components */
:root {
  --primary-color: #7d48b0;
  --primary-light: #a78bc2;
  --primary-gradient: linear-gradient(135deg, #7d48b0 0%, #a78bc2 100%);
  --surface-white: #ffffff;
  --surface-gray-50: #fafbfc;
  --surface-gray-100: #f4f6f8;
  --surface-gray-200: #e8ecf0;
  --text-primary: #1a1d29;
  --text-secondary: #6b7280;
  --text-muted: #9ca3af;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --border-light: #e2e8f0;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
  --radius-2xl: 20px;
}
`, "",{"version":3,"sources":["webpack://./styles/admin-variables.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,wBAAwB;EACxB,wBAAwB;EACxB,qEAAqE;EACrE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,0CAA0C;EAC1C,6EAA6E;EAC7E,+EAA+E;EAC/E,gFAAgF;EAChF,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* Shared Design Variables for Admin Components */\r\n:root {\r\n  --primary-color: #7d48b0;\r\n  --primary-light: #a78bc2;\r\n  --primary-gradient: linear-gradient(135deg, #7d48b0 0%, #a78bc2 100%);\r\n  --surface-white: #ffffff;\r\n  --surface-gray-50: #fafbfc;\r\n  --surface-gray-100: #f4f6f8;\r\n  --surface-gray-200: #e8ecf0;\r\n  --text-primary: #1a1d29;\r\n  --text-secondary: #6b7280;\r\n  --text-muted: #9ca3af;\r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --warning-color: #f59e0b;\r\n  --border-light: #e2e8f0;\r\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\r\n  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\r\n  --radius-sm: 6px;\r\n  --radius-md: 8px;\r\n  --radius-lg: 12px;\r\n  --radius-xl: 16px;\r\n  --radius-2xl: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
